/**
 * Compares two Date objects to determine if they represent the same calendar day.
 *
 * @param date1 - The first Date object to be compared.
 * @param date2 - The second Date object to be compared.
 * @returns A boolean indicating whether the two dates fall on the same calendar day.
 */

const validateSameDate = (date1: Date, date2: Date): boolean => {
  if (!date1 || !date2) return false;

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export default validateSameDate;
